import * as yup from 'yup'
import { Form, Formik, FormikOnSubmit } from 'formik'
import {
  Button,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalProps,
} from '@ritualco/jutsu'
import { FormikInput } from 'components/Formik'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'

const merchantListCreateSchema = yup.object({
  name: yup.string().optional().default(''),
})

type MerchantListCreateSchema = yup.InferType<typeof merchantListCreateSchema>

const MerchantListCreateForm = () => {
  const { formatMessage } = useContent()
  return (
    <Form id="merchantListCreate">
      <FormikInput
        label={formatMessage({ id: 'pmportal.restaurantLists.listName' })}
        name="name"
      />
    </Form>
  )
}

export type MerchantListCreateModalProps = {
  onSubmit: FormikOnSubmit<MerchantListCreateSchema>
} & Omit<ModalProps, 'children'>

export const MerchantListCreateModal = (
  props: MerchantListCreateModalProps
) => {
  const { onSubmit, onClose, ...modalProps } = props
  const { formatMessage } = useContent()

  return (
    <HeraModal onClose={onClose} {...modalProps}>
      <Formik<MerchantListCreateSchema>
        initialValues={merchantListCreateSchema.cast({})}
        validationSchema={merchantListCreateSchema}
        onSubmit={async (values, actions) => {
          await onSubmit(values, actions)
          actions.setSubmitting(false)
          onClose()
        }}
      >
        {props => (
          <>
            <ModalHeader>
              {formatMessage({
                id: 'pmportal.restaurantLists.createListTitle',
              })}
            </ModalHeader>
            <ModalBody>
              <MerchantListCreateForm />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="transparent"
                variant="ghost"
                mr={2}
                onClick={onClose}
              >
                {formatMessage({ id: 'pmportal.global.actionCancel' })}
              </Button>
              <Button
                type="submit"
                form="merchantListCreate"
                isLoading={props.isSubmitting}
              >
                {formatMessage({ id: 'pmportal.global.actionCreate' })}
              </Button>
            </ModalFooter>
          </>
        )}
      </Formik>
    </HeraModal>
  )
}
